'use strict';

require("core-js/modules/es6.function.bind");

var implementation = require('./implementation');

module.exports = Function.prototype.bind || implementation;